<template>
  <v-container>
    <!-- Tabs for Program and Attendance -->
    <v-tabs v-model="tab" vertical>
      <v-tab>Program</v-tab>
      <v-tab>Attendance</v-tab>

      <!-- Tab Content: Program -->
      <v-tab-item>
        <v-container>
          <!-- Group Selection -->
          <v-select v-model="selectedGroup" :items="groupList" label="Select Group" @change="fetchProgramData"
            :disabled="groupList.length === 0" item-value="id" item-text="name" />
          <program />
          <!-- Program Overview (Skeleton loader while data is loading) -->
          <!-- <v-skeleton-loader v-if="loading" :loading="loading">
            <v-card>
              <v-card-title>
                <v-skeleton-loader :loading="loading" type="heading" />
              </v-card-title>
              <v-card-subtitle>
                <v-skeleton-loader :loading="loading" type="subheading" />
              </v-card-subtitle>

              <v-list>
                <v-list-item-group v-for="index in 3" :key="index">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-skeleton-loader :loading="loading" type="heading" />
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <v-skeleton-loader :loading="loading" type="subheading" />
                      </v-list-item-subtitle>
                      <v-list>
                        <v-list-item-group v-for="set in 3" :key="set">
                          <v-list-item>
                            <v-skeleton-loader :loading="loading" type="heading" />
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-skeleton-loader>

            <v-card v-if="!loading && programData">
            <v-card-title>{{ programData.name }}</v-card-title>
            <v-card-subtitle>{{ programData.description }}</v-card-subtitle>

            <v-list>
              <v-list-item-group v-for="(workout, index) in programData.workouts" :key="index">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>{{ workout.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{
                      workout.description
                    }}</v-list-item-subtitle>
                    <v-list>
                      <v-list-item-group v-for="set in workout.sets" :key="set.id">
                        <v-list-item @click="openDrillDialog(set)">
                          <v-list-item-content>
                            <v-list-item-title>{{
                              set.name
                            }}</v-list-item-title>
                            <v-list-item-subtitle>{{
                              set.description
                            }}</v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>

          <v-dialog v-model="drillDialog" max-width="800px">
            <v-card>
              <v-card-title>{{ selectedDrill.name }}</v-card-title>
              <v-card-text>
                <video :src="selectedDrill.videoUrl" controls></video>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="drillDialog = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>-->
        </v-container>
      </v-tab-item>

      <!-- Tab Content: Attendance -->
      <v-tab-item>
        <v-container>
          <athleteAttendance :group="selectedGroup" />
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import athleteAttendance from "../club/AthleteAttendance.vue";
import program from "../../libs/program_lib.vue";

export default {
  components: {
    athleteAttendance,
    program
  },
  data() {
    return {
      tab: null, // Track which tab is selected
      selectedGroup: null,
      groupList: [
        { id: 1, name: "Group A" },
        { id: 2, name: "Group B" },
        { id: 3, name: "Group C" },
      ],
      programData: null,
      loading: false,
      drillDialog: false,
      selectedDrill: {},
    };
  },
  methods: {
    fetchProgramData(groupId) {
      this.loading = true;
      // Simulate a fetch delay
      setTimeout(() => {
        // Mock Program Data
        this.programData = {
          name: "Sample Program for Group " + groupId,
          description:
            "This is a description of the program for Group " + groupId,
          workouts: [
            {
              name: "Workout 1",
              description: "This is the first workout of the program.",
              sets: [
                {
                  id: 1,
                  name: "Set 1",
                  description: "First set of the workout",
                  drill: { name: "Drill 1", videoUrl: "/path/to/video.mp4" },
                },
                {
                  id: 2,
                  name: "Set 2",
                  description: "Second set of the workout",
                  drill: { name: "Drill 2", videoUrl: "/path/to/video2.mp4" },
                },
              ],
            },
            {
              name: "Workout 2",
              description: "This is the second workout of the program.",
              sets: [
                {
                  id: 3,
                  name: "Set 1",
                  description: "First set of the second workout",
                  drill: { name: "Drill 3", videoUrl: "/path/to/video3.mp4" },
                },
              ],
            },
          ],
        };
        this.loading = false;
      }, 1000);
    },
    openDrillDialog(set) {
      this.selectedDrill = set.drill; // Assuming `drill` is an object with video info
      this.drillDialog = true;
    },
  },
};
</script>